var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.753,
    height: 76.185,
    viewBox: "0 0 108.753 76.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_113",
    "data-name": "Grupo 113",
    transform: "translate(-464.936 -147.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56",
    transform: "translate(464.936 204.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M473.1,257.96v7.622h-.916v-1.618a3.62,3.62,0,0,1-1.365,1.257,4.135,4.135,0,0,1-3.967.02,3.639,3.639,0,0,1-1.4-1.4,4.512,4.512,0,0,1,.019-4.23,3.6,3.6,0,0,1,1.482-1.394,4.592,4.592,0,0,1,2.134-.487,3.384,3.384,0,0,1,1.794.526,3.559,3.559,0,0,1,1.306,1.365l.1-1.657Zm-1.891,6.2a2.876,2.876,0,0,0,.975-2.047v-1.091a3.1,3.1,0,0,0-1.131-1.794,3.179,3.179,0,0,0-2.047-.721,3.248,3.248,0,0,0-1.6.4,2.934,2.934,0,0,0-1.141,1.131,3.324,3.324,0,0,0-.419,1.686,3.176,3.176,0,0,0,.428,1.618,3.258,3.258,0,0,0,1.16,1.179,3.028,3.028,0,0,0,1.588.439A3.164,3.164,0,0,0,471.213,264.159Z",
    transform: "translate(-464.936 -250.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M483.745,252.4v3.45H486.1v.741h-2.359v6.784h-.936v-6.784h-1.618v-.741h1.618V252.4Z",
    transform: "translate(-471.679 -248.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M492.234,245.834v14.815h-.916V245.834Z",
    transform: "translate(-475.879 -245.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M503.55,254.589v7.622h-.916v-1.618a3.625,3.625,0,0,1-1.365,1.257,4.135,4.135,0,0,1-3.967.02,3.638,3.638,0,0,1-1.4-1.4,4.512,4.512,0,0,1,.019-4.23,3.6,3.6,0,0,1,1.482-1.394,4.588,4.588,0,0,1,2.134-.487,3.384,3.384,0,0,1,1.794.526,3.563,3.563,0,0,1,1.306,1.365l.1-1.657Zm-1.891,6.2a2.876,2.876,0,0,0,.975-2.047v-1.091a3.1,3.1,0,0,0-1.131-1.794,3.176,3.176,0,0,0-2.046-.721,3.25,3.25,0,0,0-1.6.4,2.936,2.936,0,0,0-1.14,1.131,3.324,3.324,0,0,0-.42,1.686,3.171,3.171,0,0,0,.429,1.618,3.258,3.258,0,0,0,1.16,1.179,3.028,3.028,0,0,0,1.588.439A3.164,3.164,0,0,0,501.659,260.788Zm.234-8.09-1.95-2.183-1.91,2.183h-.916l2.827-3.1h.02l2.846,3.1Z",
    transform: "translate(-477.565 -247.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M518.912,258.393a2.308,2.308,0,0,1,.7,1.647V265.6h-.936v-5.3a1.885,1.885,0,0,0-.487-1.238,1.741,1.741,0,0,0-1.286-.5,2.838,2.838,0,0,0-2.485,1.413,2.935,2.935,0,0,0-.4,1.53V265.6H513.1v-7.622h.8l.078,1.7a2.9,2.9,0,0,1,1.257-1.394,3.825,3.825,0,0,1,1.959-.517A2.38,2.38,0,0,1,518.912,258.393Z",
    transform: "translate(-484.916 -250.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M529.081,252.4v3.45h2.359v.741h-2.359v6.784h-.936v-6.784h-1.618v-.741h1.618V252.4Z",
    transform: "translate(-490.484 -248.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M537.525,255.76v7.622h-.916V255.76Zm-.032-3.339h-.812a.135.135,0,0,0-.135.135v.812a.135.135,0,0,0,.135.135h.812a.135.135,0,0,0,.135-.135v-.812A.135.135,0,0,0,537.492,252.421Z",
    transform: "translate(-494.64 -248.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M546.146,265.545a4.317,4.317,0,0,1-3.45-.283,3.769,3.769,0,0,1-1.452-1.423,3.981,3.981,0,0,1-.527-2.037,3.927,3.927,0,0,1,.536-2.038,3.869,3.869,0,0,1,1.453-1.423,3.984,3.984,0,0,1,1.989-.517,4.07,4.07,0,0,1,2.67.9l-.487.624a3.383,3.383,0,0,0-2.125-.76,2.986,2.986,0,0,0-1.57.429,3.149,3.149,0,0,0-1.131,1.17,3.225,3.225,0,0,0-.419,1.618,3.173,3.173,0,0,0,.419,1.608A3.154,3.154,0,0,0,544.83,265a3.29,3.29,0,0,0,2.008-.682l.507.565A3.917,3.917,0,0,1,546.146,265.545Z",
    transform: "translate(-496.37 -250.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M553.512,259.691a3.93,3.93,0,0,1,1.472-1.462,4.251,4.251,0,0,1,4.133,0,3.854,3.854,0,0,1,1.462,1.462,4.013,4.013,0,0,1,.527,2.018,3.967,3.967,0,0,1-2,3.48,4.065,4.065,0,0,1-2.076.536,4.184,4.184,0,0,1-2.076-.517,3.751,3.751,0,0,1-1.452-1.433,4.076,4.076,0,0,1-.526-2.066A3.956,3.956,0,0,1,553.512,259.691Zm.8,3.655a3.126,3.126,0,0,0,1.141,1.17,3.12,3.12,0,0,0,3.158,0,3.129,3.129,0,0,0,1.14-1.17,3.226,3.226,0,0,0,.42-1.618,3.28,3.28,0,0,0-.42-1.627,3.11,3.11,0,0,0-1.14-1.18,3.036,3.036,0,0,0-1.579-.428,2.919,2.919,0,0,0-1.6.458,3.274,3.274,0,0,0-1.131,1.2,3.292,3.292,0,0,0,.01,3.2Z",
    transform: "translate(-501.455 -250.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M568.361,269.081a.615.615,0,0,1,.448-.2.651.651,0,0,1,.458.2.637.637,0,0,1,0,.935.649.649,0,0,1-.458.2.662.662,0,0,1-.448-1.131Z",
    transform: "translate(-507.756 -255.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M580.353,245.334v15.108h-1.832v-1.268a4.129,4.129,0,0,1-1.433,1.072,4.4,4.4,0,0,1-1.862.39,3.929,3.929,0,0,1-2.047-.546,3.784,3.784,0,0,1-1.432-1.53,4.813,4.813,0,0,1-.517-2.271,4.535,4.535,0,0,1,.546-2.271,3.667,3.667,0,0,1,1.5-1.472,4.537,4.537,0,0,1,2.163-.507,4.269,4.269,0,0,1,1.764.38,3.283,3.283,0,0,1,1.335,1.043v-8.129Zm-2.778,13.178a2.568,2.568,0,0,0,.946-1.521v-1.52a2.548,2.548,0,0,0-.994-1.433,2.865,2.865,0,0,0-1.735-.555,2.7,2.7,0,0,0-2.358,1.355,2.934,2.934,0,0,0,0,2.856,2.749,2.749,0,0,0,.994,1.014,2.625,2.625,0,0,0,1.365.37A2.829,2.829,0,0,0,577.575,258.512Z",
    transform: "translate(-509.027 -245.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M591.83,254.8v8.07h-1.813V254.8ZM591.6,251.2h-1.361a.226.226,0,0,0-.226.226v1.361a.226.226,0,0,0,.226.226H591.6a.226.226,0,0,0,.226-.226v-1.361A.226.226,0,0,0,591.6,251.2Z",
    transform: "translate(-516.82 -247.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M604.367,257.125v8.128a3.69,3.69,0,0,1-.565,2.008,3.959,3.959,0,0,1-1.609,1.423,5.36,5.36,0,0,1-2.446.527,5.015,5.015,0,0,1-2.115-.41,7.326,7.326,0,0,1-1.784-1.208l1.072-1.248a5.413,5.413,0,0,0,1.326.946,3.306,3.306,0,0,0,1.462.321,3.043,3.043,0,0,0,2.076-.643,2.251,2.251,0,0,0,.75-1.735l.02-1.52a3.24,3.24,0,0,1-1.316,1.218,4.22,4.22,0,0,1-2,.458,3.885,3.885,0,0,1-2.047-.565,4.186,4.186,0,0,1-1.491-1.54,4.519,4.519,0,0,1,.019-4.376,4.226,4.226,0,0,1,1.55-1.55,4.094,4.094,0,0,1,2.086-.565,4.462,4.462,0,0,1,1.91.41,3.08,3.08,0,0,1,1.306,1.053l.136-1.131Zm-2.807,6.2a2.6,2.6,0,0,0,.994-1.482v-1.6a2.655,2.655,0,0,0-1.034-1.414,2.97,2.97,0,0,0-1.754-.536,2.735,2.735,0,0,0-1.988.78,2.657,2.657,0,0,0-.8,1.988,2.8,2.8,0,0,0,1.384,2.446,2.709,2.709,0,0,0,1.4.38A2.923,2.923,0,0,0,601.56,263.324Z",
    transform: "translate(-518.948 -250.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M615.947,254.8v8.07h-1.813V254.8Zm-.226-3.607H614.36a.227.227,0,0,0-.226.226v1.361a.226.226,0,0,0,.226.226h1.361a.226.226,0,0,0,.226-.226v-1.361A.226.226,0,0,0,615.721,251.2Z",
    transform: "translate(-526.824 -247.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M622.578,251.3v3.567h2.2v1.443h-2.2v6.609h-1.833v-6.609h-1.481v-1.443h1.481V251.3Z",
    transform: "translate(-528.952 -247.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_222",
    "data-name": "Caminho 222",
    d: "M638.077,257.125v8.07h-1.813v-1.326a4.175,4.175,0,0,1-1.248,1.043,3.609,3.609,0,0,1-1.852.478,4.312,4.312,0,0,1-2.076-.5,3.615,3.615,0,0,1-1.463-1.452,5.1,5.1,0,0,1,.02-4.591,3.923,3.923,0,0,1,1.5-1.521,4.177,4.177,0,0,1,2.1-.536,3.465,3.465,0,0,1,1.793.449,3.657,3.657,0,0,1,1.228,1.169l.136-1.286Zm-2.719,6.208a2.474,2.474,0,0,0,.906-1.51v-1.6a2.489,2.489,0,0,0-.975-1.394,2.822,2.822,0,0,0-1.7-.536,2.645,2.645,0,0,0-1.335.351,2.581,2.581,0,0,0-.974.984,2.839,2.839,0,0,0-.36,1.433,2.792,2.792,0,0,0,.37,1.423,2.824,2.824,0,0,0,.994,1.023,2.575,2.575,0,0,0,1.365.38A2.688,2.688,0,0,0,635.357,263.333Z",
    transform: "translate(-533.028 -250.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_223",
    "data-name": "Caminho 223",
    d: "M649.49,245.334v15.108h-1.813V245.334Z",
    transform: "translate(-540.737 -245.334)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57",
    transform: "translate(496.993 147.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_224",
    "data-name": "Caminho 224",
    d: "M581.5,147.826h-4.924a.818.818,0,0,0-.818.819v4.922a.818.818,0,0,0,.818.819H581.5a.818.818,0,0,0,.817-.819v-4.922A.819.819,0,0,0,581.5,147.826Z",
    transform: "translate(-542.963 -147.826)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_225",
    "data-name": "Caminho 225",
    d: "M558.254,164.639h-4.924a.818.818,0,0,0-.818.82v4.194a19.59,19.59,0,0,0-11.463-4.944q-.818-.069-1.656-.07-.816,0-1.616.066a19.68,19.68,0,0,0-.041,39.224q.818.068,1.657.07c.543,0,1.083-.022,1.615-.066a19.59,19.59,0,0,0,11.5-4.948v4.194a.818.818,0,0,0,.818.82h4.924a.819.819,0,0,0,.818-.82V165.459A.819.819,0,0,0,558.254,164.639Zm-17.246,32.7a13.271,13.271,0,0,1-1.6.1h-.019a13.437,13.437,0,0,1-1.657-.1,13.119,13.119,0,0,1,1.657-26.135h.026a13.963,13.963,0,0,1,1.63.1,13.121,13.121,0,0,1-.041,26.037Z",
    transform: "translate(-519.715 -154.8)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_226",
    "data-name": "Caminho 226",
    d: "M575.761,212.935v4.177c.354-.246.7-.5,1.041-.768a23.1,23.1,0,0,0,5.517-6.243V198.27A19.619,19.619,0,0,1,575.761,212.935Z",
    transform: "translate(-542.963 -168.75)",
    fill: "#2073ba"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkMode);
export default __webpack_public_path__ + "static/media/logo-dark-mode.79e05f6dd9da688a0f1b79bdd6d19825.svg";
export { ForwardRef as ReactComponent };